const people = [
    {
        id: 1,
        image: "images/family.jpg",
        name: "Mwanzia Family",
        title: "new client",
        quote: 
        "Makao Homes provided us with the best service you could ever get from any Real Estate platform. It has helped us settle in and be comfortable with our new home."
    },

    {
        id: 2,
        image: "images/james.jpg",
        name: "James Doakes",
        title: "Project Manager",
        quote: 
        "Makao Homes provided me with the necessary office space i needed to boost the growth of my company and to run my business",
    },


    {
        id: 3,
        image: "images/dexter.jpg",
        name: "Dexter Morgan",
        title: "Manager",
        quote: 
        "Makao Homes is the best you could get. The Service is top notch, Wide range of properties and prices to suit your needs.",
    },

    {
        id: 4,
        image: "images/family2.jpg",
        name: "Happy Family",
        title: "New Client",
        quote: 
        "Makao homes is the best place to buy high qaulity properties at affordable prices."
    },
];

export default people


export const footer = [
    {
      title: "Company",
      text: [{ list: "Privacy Policy" }, { list: "Terms and Conditions" }],
    },
    {
      title: "About",
      text: [{ list: "Testimonials" }, { list: "Contact Us"}],
    },
  ]